import axios from 'axios';

export const getRequest = (route, options = {}) => {
    return axios.get(route, { signal: options.signal });
};

export const patchRequest = (route, data = {}, params) => {
    return axios.patch(route, data, { params });
};

export const postRequest = (route, data = {}, params) => {
    return axios.post(route, data, { params });
};

export const putRequest = (route, data = {}, params) => {
    return axios.put(route, data, { params });
};

export const deleteRequest = (route, data = {}, params) => {
    return axios.delete(route, { data, params });
};
